import { useCallback, useState } from 'react';

type useBoolReturn = [
  // The Value
  boolean,
  // Set True
  () => void,
  // Set False
  () => void
];

export const useBool = (initialValue?: boolean): useBoolReturn => {
  const [bool, setBool] = useState<boolean>(initialValue || false);

  const setTrue = useCallback(() => setBool(true), [setBool]);
  const setFalse = useCallback(() => setBool(false), [setBool]);

  return [bool, setTrue, setFalse];
};
